import React from "react";

import { Main, Bold } from "../styles";

export default function Answer() {
  return (
    <Main>
      <Bold as="h1" style={{ fontSize: 22 }} color="#4B4B4B">
        Conjunto de equipamentos para emergência e EPI
      </Bold>
      <p>
        A - Calços com dimensões mínimas: 150 mm x 200 mm x 150 mm (utilitário,
        caminhão e carreta 2 calços, bitrem 4 calços).
      </p>
      <p>
        B - Jogo de ferramentas (mínimo): 01 alicate universal, 01 chave de
        fenda ou philips, 01 chave para desconexão do cabo da bateria.
      </p>
      <p>
        C - Cones de sinalização para Cilindro e Granel: 04 (quatro) cones para
        sinalização da via (conforme ABNT NBR 15071) Alaranjados com refletivos
        brancos.
      </p>
      <p>
        D - Extintor de incêndio do veículo automotor que deverá estar na
        cabine: Verificar: tipo (2A:20-BC), data de validade, prazo de
        durabilidades, anel de identificação de manutenção, certificação
        Inmetro, rótulo contendo procedimento de uso, estando a identificação
        legível.
      </p>
      <p>
        E - Extintor de incêndio da carga: Deverá estar afixado um em cada
        lateral do veículo ou, no caso de fracionado, estar afixado nas laterais
        sobre o chassi ou a frente do compartimento de carga próximo a cabine,
        longe das válvulas de descarga. No caso de caminhão trator poderá estar
        afixado atrás da cabine, um em cada lateral. Não poderá estar dentro do
        compartimento de carga:
      </p>
      <table>
        <tr>
          <th className="p-2">Tipo do Veículo e Carga</th>
          <th className="p-2">Número Mínimo de Extintores</th>
        </tr>
        <tr>
          <td>Granel</td>
          <td>
            • 2 PQS 8 kg e 4-A:30-BC ou 30-BC; ou
            <br /> • 3 CO2 6kg e 5-B:C
          </td>
        </tr>
        <tr>
          <td>Envasado</td>
          <td>
            • 1 PQS 8 kg 4-A:30-BC ou 30-BC; ou
            <br />• 2 CO2 6kg e 5-B:C
          </td>
        </tr>
      </table>
      <br />
      <p>
        F - EPI (Equipamento de Proteção Individual) ABNT NBR 9735: 01 (um) par
        de Luvas de material adequado ao(s) produto(s) transportado(s) (luva de raspa, 
        vaqueta ou nitrílica e capacete com jugular). Deverá apresentar o nº do CA, lote de fabricação e o nome
        da empresa fabricante (Condutor e Ajudante).
      </p>
    </Main>
  );
}
